import _ from 'lodash'
import { countries } from '../content/supportedCountries'
import { updateRevinateCartField } from './revinateCart'

/**
 * Maps redux-form field names onto RevinateCart field names and pushes any
 * changed values into the abandoned-cart service. Driven by each form's
 * reduxForm({ onChange }) config, which hands us diffed values for free.
 */

// guestForm field -> RevinateCart field
const GUEST_FIELD_MAP = {
	firstName: 'firstname',
	lastName: 'lastname',
	email: 'email',
	phone: 'phone',
	address1: 'address',
	city: 'city',
	country: 'country',
	stateProv: 'state',
}

const PAYMENT_FIELD_MAP = {
	zip: 'zipcode',
}

const COUNTRY_NAME_BY_CODE = countries.reduce((acc, country) => {
	acc[country.alpha2Code] = country.name
	return acc
}, {})

const STATE_NAME_BY_CODE = countries.reduce((acc, country) => {
	(country.states || []).forEach(state => {
		if (state.code) acc[state.code] = state.name
		if (state.codeGeo) acc[state.codeGeo] = state.name
	})
	return acc
}, {})

const FIELD_TRANSFORMS = {
	country: code => COUNTRY_NAME_BY_CODE[code] || code,
	stateProv: code => STATE_NAME_BY_CODE[code] || code,
}

function syncByMap(fieldMap, values = {}, previousValues = {}) {
	Object.keys(fieldMap).forEach(formField => {
		if (values[formField] !== previousValues[formField]) {
			const transform = FIELD_TRANSFORMS[formField]
			const value = transform ? transform(values[formField]) : values[formField]
			updateRevinateCartField(fieldMap[formField], value || '')
		}
	})
}

export function syncRevinateGuestFields(values, previousValues) {
	syncByMap(GUEST_FIELD_MAP, values, previousValues)
}

const PAYMENT_SYNC_DEBOUNCE_MS = 500

const debouncedSyncPayment = _.debounce(values => {
	syncByMap(PAYMENT_FIELD_MAP, values)
}, PAYMENT_SYNC_DEBOUNCE_MS)

export function syncRevinatePaymentFields(values, previousValues = {}) {
	const changed = Object.keys(PAYMENT_FIELD_MAP).some(
		formField => values[formField] !== previousValues[formField]
	)

	if (changed) {
		debouncedSyncPayment(values)
	}
}


// WEBPACK FOOTER //
// ./src/utilities/revinate/syncRevinateFromForm.js